import { StatusTone } from "./statusTone.utils";

/** The job status master list (ops-backend JOB_STATUS_MASTER_LIST). */
export enum JobStatus {
  SERVICE_REQUEST_IN = "Service Request In",
  UNSCHEDULED = "Unscheduled",
  SCHEDULED = "Scheduled",
  SELF_SCHEDULING_LINK_SENT = "Self-Scheduling Link Sent",
  EN_ROUTE = "Open: En Route",
  IN_PROGRESS = "Open: In-Progress",
  READY_FOR_BILLING = "Open: Ready For Billing",
  CLOSED = "Closed",
  WITHDRAWN = "Withdrawn",
  WITHDRAWN_RESCHEDULE = "Withdrawn: Reschedule",
}

// Anything not listed (Scheduled included) stays neutral so the job that is underway stands out.
export const JOB_STATUS_TONES: Partial<Record<JobStatus, StatusTone>> = {
  [JobStatus.EN_ROUTE]: StatusTone.ACTIVE,
  [JobStatus.IN_PROGRESS]: StatusTone.ACTIVE,
  [JobStatus.READY_FOR_BILLING]: StatusTone.ACTIVE,
  [JobStatus.CLOSED]: StatusTone.DONE,
  [JobStatus.WITHDRAWN]: StatusTone.EXCEPTION,
  [JobStatus.WITHDRAWN_RESCHEDULE]: StatusTone.EXCEPTION,
};

export const jobStatusTone = (status?: string | null): StatusTone =>
  JOB_STATUS_TONES[status as JobStatus] ?? StatusTone.NEUTRAL;
